<template>
  <div class="progress-container pa-4">
    <v-row align="center" justify="center">
      <v-col cols="12" clas="cover">
        <div class="status-text mb-2 text-center" :class="statusClass">
          {{ statusText }}
        </div>
        <div class="show">
          <v-progress-linear
            :value="progressValue"
            :color="progressColor"
            height="25"
            rounded
            striped
            class="mb-2"
          >
            <template v-slot:default="{ value }">
              <strong>{{ persian(Math.ceil(value)) }}%</strong>
            </template>
          </v-progress-linear>
          <v-tooltip top v-if="status !== 'success'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :color="
                  status === 'process'
                    ? 'primary'
                    : status === 'failed'
                    ? 'red'
                    : ''
                "
                fab
                x-small
                style="width: 25px; height: 25px"
                :loading="loading"
                v-bind="attrs"
                v-on="on"
                @click="fetchProgress"
              >
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </template>
            <span>{{
              status === "process"
                ? "به‌روزرسانی "
                : status === "failed"
                ? " تلاش مجدد"
                : ""
            }}</span>
          </v-tooltip>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import JwtService from "@/core/plugins/TitleRibbon/assets/js/jwt.service";

export default {
  name: "progress_createauto",
  props: {
    info: { type: Object },
  },
  data() {
    return {
      type: "visitcard",
      progressInterval: null,
      images: null,
      progressValue: 0,
      status: "process", // 'loading', 'error', 'completed'
      loading: false,
      url_: "",
      hinturl:
        "لیتک سایت باید به صورت رویرو وارد شود https://terminalads.com :  ",
      url: "",
      flagUrl: false,
      errorurl: "",
      urlRules: [
        (v) => !v || v.length <= 100 || "حداکثر ۱۰۰ کاراکتر مجاز است",
        (v) =>
          !v ||
          this.isURL(v) ||
          " https://terminalads.com :   لینک سایت باید بصورت روبرو وارد شود",
      ],
      Ai_Text: "",
      flag: false,
      mylastQr: false,
      qrId: 0,
      qrloading: false,
      qrselectloading: false,
      selectedQr: null,
      QrData: [],
      countData: 0,
      selectedRows: false,
      tableProps: {
        page: 1,
        length: 100000,
        search: "",
        sort: "desc",
      },
      search: "",
      pagination: {},
      list: [],
      firstPage: false,
      currentPage: 1,
      loadingdata: false,
      perPage: 100000,
      page: null,
      headers: [
        { text: "ردیف", value: "index" },
        { text: "عنوان", value: "title" },
        { text: "لینک", value: "link" },
      ],
      isOldData: false,
      oldData: [],
      file: null,
      createdId: "",
      // url: "https://robot-api.terminalads.com/api",
      isLastPage: false,
      indexAt: -1,
      categoryName: "",
      defaultCatName: "",
      img: {
        items: {},
        categories: [],
      },
      qrSvgDataUrl: "",
      loading: false,
      orders: [
        { name: "userName" },
        { name: "workField" },
        { name: "aboutUs" },
        { name: "extraFields" },
        {
          name: "video_gallery",
        },
        { name: "photo" },
        { name: "phoneNumber" },
        { name: "fax" },
        { name: "location" },
        { name: "codePostal" },
        { name: "email" },
        { name: "website" },
      ],
      theme: "MobileViwer",
      destItems: [],
      dtUrl: "",
      Textbusiness: "",
      perfix_business: "",
      cardTexts: {
        auto_build: null,
        auto_id: null,
        advanceSettings: {
          viewConfigs: {
            autoCsvDownload: false,
            showCClubOnload: false,
            forcedSubmission: "optional",
          },
          manifest: {
            icon48: "",
            icon144: "",
            screenshotWide: "",
            screenshot600: "",
          },
        },
        customerClub: {
          title: "عضویت در باشگاه مشتریان",
          description: "",
          configs: {
            patternId: 487,
            smsType: "pattern",
            isActive: true,
            message: {},
          },
        },
        userName: "",
        workField: "",
        aboutUs: "",
        video_single: null,
        // video_single: {
        //   name: "",
        //   videos: [],
        // },
        video_gallery: [
          {
            name: "گالری ویدئو",
            images: [
              {
                name: "خوش آمدگویی",
                title: "",
                url: "https://www.aparat.com/video/video/embed/videohash/a89rkt7/vt/frame",
                file_link: "https://www.aparat.com/v/a89rkt7",
                description: "",
                link: "https://www.aparat.com/v/a89rkt7",
                id: 15,
              },
            ],
          },
        ],
        photo: {
          gallery: [
            {
              name: "",
              images: [],
            },
          ],
          headBackground: "/media/defaults/visitFirstDefault.webp",
          profile: "/media/defaults/qrLogo.webp",
          transition: "scale",
          hasWelcome: false,
          hasGif: false,
          hasGame: false,

          previewerQr: {
            previewer: {
              gif: "",
              game: {},
              transition: "scale",
            },
          },
        },
        extraFields: [
          {
            icon: "",
            name: "",
            value: "",
          },
        ],
        phoneNumber: [
          {
            number: "",
          },
        ],
        fax: "",
        location: "",
        codePostal: "",
        email: "",
        website: "",
        visitName: "کارت ویزیت",
        pallete: {
          headColor: "linear-gradient(to top, #AA7630FF, #EBCB63FF)",
          bodyColor: "linear-gradient(to top right , #AA7630FF, #EBCB63FF)",
          textColor: "#ffffff",
          borderColor: "#393939",
        },
        organizationName: "",
        subOrgan: "",
        companyNumber: "",
        city: "",
        province: "",
        country: "",
        socialMedia: {
          // address: [
          //   {
          //     label: "آدرس",
          //     text: "لینک سایت مورد نظر را وارد نمایید",
          //     hint: "لینک سایت مورد نظر را وارد نمایید",
          //     pattern: "",
          //     prefix: "URL",
          //     url: "",
          //     img: "/media/socialIcon/40icon/location.svg",
          //     svg: "svgLocation",
          //   },
          //   {
          //     label: "آدرس",
          //     text: "لینک سایت مورد نظر را وارد نمایید",
          //     hint: "لینک سایت مورد نظر را وارد نمایید",
          //     pattern: "",
          //     prefix: "URL",
          //     url: "",
          //     img: "/media/socialIcon/40icon/location.svg",
          //     svg: "svgLocation",
          //   },
          // ],
          // instagram: [
          //   {
          //     label: "اینستاگرام",
          //     text: "نام کاربری خود را وارد نمایید",
          //     hint: "نام کاربری خود را وارد نمایید",
          //     pattern: "",
          //     prefix: "@",
          //     url: "",
          //     img: "/media/socialIcon/40icon/instagram.svg",
          //     svg: "svgInstagram",
          //   },
          // ],
          // whatsapp: [
          //   {
          //     label: "واتساپ",
          //     text: "",
          //     hint: "",
          //     pattern: "",
          //     prefix: "mdi-phone",
          //     url: "",
          //     img: "/media/socialIcon/40icon/whatsapp.svg",
          //     svg: "svgWhatsapp",
          //   },
          // ],
        },
        center: [51.420296, 35.732379],
        coordinates: [51.420296, 35.732379],
        address: "",
        apiKey:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
      },
      qrDesign: {
        color: "#000000",
        background: "#FFFFFF",
        pattern: "square",
      },
      domainId: 5,
      createdDomain: "qrland.in/",
      rules: [
        (v) => !!v || "فیلد فعالیت الزامی است",
        (v) =>
          !v || this.spellChecker(v) || "متن وارد شده باید به زبان فارسی باشد!",
        (v) => (v && v.length >= 2) || "حداقل دو کاراکتر باید وارد شود!",
        (v) => {
          if (this.perfix_business !== "")
            return (
              (v && v.trim().split(" ").length >= 1) ||
              "حداقل یک کلمه وارد کنید"
            );
          else
            return (
              (v && v.trim().split(" ").length >= 2) ||
              "حداقل دو کلمه وارد کنید"
            );
        },
        (v) => (v && v.length <= 100) || "حداکثر ۱۰۰ کاراکتر مجاز است",
      ],
      progressDialog: false,
      progressTitle: "اطلاع‌رسانی",
      progressMessage: "",
      showProgress: false,
      loading: false,
      result: [],
      translatedText: "",
      business: "",
      tabs: 0,
      type: "",
      count: 1000,
      helpData: [],
      serviceName: "Qrland",
      componentName: "createqr",
    };
  },
  computed: {
    statusText() {
      switch (this.status) {
        case "failed":
          return "ساخت کیو آر با خطا مواجه شده";
        case "process":
          return "در حال ساخت کیو آر";
        case "success":
          return "تکمیل شده";
        default:
          return "در حال ساخت";
      }
    },
    statusClass() {
      return {
        "error-text": this.status === "failed",
        "loading-text": this.status === "process",
        "completed-text": this.status === "success",
      };
    },
    progressColor() {
      switch (this.status) {
        case "failed":
          return "red";
        case "process":
          return "blue";
        case "success":
          return "green";
        default:
          return "blue";
      }
    },
  },
  mounted() {
    this.fetchProgress();
    this.progressInterval = setInterval(() => {
      if (this.status !== "success") {
        this.fetchProgress();
      } else {
        clearInterval(this.progressInterval);
      }
    }, 10000000);
  },
  beforeDestroy() {
    clearInterval(this.progressInterval);
  },
  methods: {
    async fetchDigikalaData(product) {
      try {
        if (!product) {
          //   "محصولی در دیجی‌کالا یافت نشد. از داده‌های موجود استفاده می‌شود."
          this.cardTexts.singleProduct.name =
            this.cardTexts.singleProduct.name || this.ProductName;
          this.cardTexts.singleProduct.description =
            this.cardTexts.singleProduct.description || "";
          return;
        } else {
          //response.payload.payload.product_info.details {label value} //for array
          //response.payload.payload.product_info.gallery {name images{id,url,title,description,name}} //for array
          //response.payload.payload.product_info.options {size //for array, color //for array}
          //response.payload.payload.product_info.sub_products {type[] ,count[],weight[]}
          //response.payload.payload.product_info.description

          const productInfo = product.data;
          const existingFeatures = this.cardTexts.Features.details[0].value;
          // Map product information to cardTexts.Features
          const newFeatures = [];
          product.details.forEach((item) => {
            if (item.label && item.value) {
              newFeatures.push({
                label: item.label,
                value: item.value,
                showIt: true,
              });
            }
          });
          if (product.model) {
            newFeatures.push({
              label: "سریال",
              value: productInfo.series,
              showIt: !!productInfo.series,
            });
          }
          if (product.model) {
            newFeatures.push({
              label: "برند",
              value: productInfo.brand,
              showIt: !!productInfo.brand,
            });
          }
          if (product.model) {
            newFeatures.push({
              label: "مدل",
              value: product.model,
              showIt: !!productInfo.model,
            });
          }
          if (product.model) {
            newFeatures.push({
              label: "کشور",
              value: product.country,
              showIt: !!productInfo.country,
            });
          }
          this.cardTexts.Features.details[0].value = [
            ...existingFeatures,
            ...newFeatures,
          ];
          // this.cardTexts.Features.details[0].value.push(newFeatures);
          // Map product information to cardTexts.singleProduct
          this.cardTexts.singleProduct.name =
            productInfo.title || this.ProductName;
          this.cardTexts.singleProduct.description =
            productInfo.description || "";
          this.cardTexts.singleProduct.price = productInfo.price || 0;
          this.cardTexts.singleProduct.discount = productInfo.discount || 0;

          // Extract specifications
          const specs = productInfo.extra || [];

          // Map specifications to new extraFields
          const newSpecItems = specs.map((attr) => {
            if (!!attr.label && !!attr.value)
              return {
                name: attr.label,
                value: attr.value,
              };
          });

          // Assign icons for new specifications
          const icons = await this.assignIcons(
            newSpecItems.map((item) => item.name),
          );

          // Merge new specifications with existing extraFields (avoid duplicates)
          const existingExtraFields = this.cardTexts.extraFields || [];
          const existingNames = new Set(
            existingExtraFields.map((item) => item.name),
          );

          const mergedExtraFields = [
            ...existingExtraFields,
            ...newSpecItems
              .filter((item) => !existingNames.has(item.name)) // Avoid duplicates
              .map((item, index) => ({
                icon: icons[index] || "mdi-information",
                name: item.name,
                value: item.value,
              })),
          ];

          // Update cardTexts.extraFields
          this.cardTexts.extraFields = mergedExtraFields;

          // Map images from Digikala
          const listImages =
            productInfo.gallery[0]?.images?.map((item, index) => ({
              url: item.url,
              title: "",
              name: "",
              id: index + 1,
              description: "",
              link: "",
            })) || [];

          // Merge Digikala images with existing gallery images
          this.cardTexts.photo.gallery = this.cardTexts.photo.gallery || [
            { name: "گالری تصاویر", images: [] },
          ];
          this.cardTexts.photo.gallery[0].images = [
            ...this.cardTexts.photo.gallery[0].images,
            ...listImages,
          ];
          // this.cardTexts.photo.gallery[0].images.push(
          //   listImages
          // )
          // Set aboutUs
          this.cardTexts.aboutUs =
            productInfo.description || this.cardTexts.aboutUs;

          // Set organizationName
          this.cardTexts.organizationName =
            this.cardTexts.organizationName || productInfo.brand || "";

          this.$toast.success("اطلاعات محصول با موفقیت دریافت شد");
        }
      } catch (error) {
        console.error("Error fetching Digikala data:", error);
        //this.$toast.error("خطا در دریافت اطلاعات محصول");
      }
    },
    generateUID() {
      return "xxxx".replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    filterEnglishOnly(text) {
      return text.replace(/[^a-zA-Z0-9]/g, "");
    },
    async qrUpdate(final = false) {
      this.loading = true;
      try {
        const data = new FormData();
        data.append(
          "type",
          this.type === "visitcard"
            ? "VisitCard"
            : this.type === "product"
            ? "singleProduct"
            : "labelProduct",
        );
        // data.append("image", this.info.image);
        data.append("qrType", "dynamic");
        data.append("domain", this.createdDomain);
        data.append("identifier", this.info.identifier);
        data.append("_method", "PUT");
        data.append("qr", JSON.stringify(this.info.qr));
        data.append("qr_id", this.info.qrId);
        data.append(
          "data",
          JSON.stringify({
            theme: this.info.data.theme,
            data: this.cardTexts,
            orders: this.info.data.orders,
          }),
        );
        const { data: response } = await this.$api.post(
          "/v1/testQr/update",
          data,
          {
            headers: { "Content-Type": "multipart/form-data" },
          },
        );

        this.$toast.success("کیوآر کارت ویزیت شما باموفقیت ویرایش شد.");

        if (final) {
          this.$forceUpdate();
          this.goto("qr/list");
          this.$nextTick(() => {
            //   window.location.reload();
          });
          // this.goto("qr/list", { refresh: Date.now() });
        }
      } catch (error) {
        // if (response?.data?.errors) {
        //   if (
        //     response.data.errors.identifier[0] ===
        //       "آدرس کیوآر قبلا انتخاب شده است." &&
        //     response?.status === 422
        //   ) {
        //     const parts = this.filterEnglishOnly(this.dtUrl).split("-");
        //     const lastPart = parts[parts.length - 1];

        //     if (!isNaN(lastPart)) {
        //       parts[parts.length - 1] = Number(lastPart) + 1;

        //       this.dtUrl = parts.join("-");
        //     } else {
        //       this.dtUrl = parts.join("-");
        //       this.dtUrl = `${this.filterEnglishOnly(this.dtUrl)}-0`;
        //       this.markQr();
        //     }
        //   } else {
        //     Object.keys(response.data.errors).forEach((item) => {
        //       this.$toast.error(response.data.errors[item][0], {
        //         timeout: 3000,
        //       });
        //     });
        //   }
        // } else {
        //   // this.$toast.error("ساخت کیوآر با خطا روبرو شد!");
        // }
        // // this.$toast.error("خطا در به‌روزرسانی کیوآر!");
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    header() {
      return {
        Authorization: JwtService.getToken()
          ? `Bearer ${JwtService.getToken()}`
          : null,
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*",
        "Content-Type": "application/json",
      };
    },
    tryprocess(id) {
      //https://ai-api.terminalads.com/api/process/tryAgain/${qr_id}
      axios
        .get(`${this.$aiApi}/process/tryAgain/${id}`, {
          headers: this.header(),
        })
        .then((response) => {
          // this.$toast.success("فرآیند با موفقیت تکرار شد.");
          this.checkProcess(id);
        })
        .catch((error) => {
          console.error("Error retrying process:", error);
          // this.$toast.error("خطا در تکرار فرآیند!");
        });
    },
    async checkProcess(id) {
      axios
        .get(`${this.$aiApi}/process/check/${id}`, {
          headers: this.header(),
        })
        .then(async (data) => {
          //response.id
          //response.status
          //response.error
          //response.end_at
          //response.payload.payload.data.images
          //response.payload.payload.data.title_en
          //response.payload.payload.step //for step check
          //response.payload.payload.max_step //for check
          //response.payload.payload.imagesProcessType
          //response.payload.payload.product_info.brand
          //response.payload.payload.product_info.title
          //response.payload.payload.product_info.details {label value} //for array
          //response.payload.payload.product_info.gallery {name images{id,url,title,description,name}} //for array
          //response.payload.payload.product_info.options {size //for array, color //for array}
          //response.payload.payload.product_info.sub_products {type[] ,count[],weight[]}
          //response.payload.payload.product_info.description
          //response.patload.payload.data.remove_bg_img //logo
          //response.patload.payload.imagesProcessType
          const response = data.data;
          this.type = response.payload.payload.imagesProcessType || "visitcard";

          this.status = response.status;
          this.images = response.payload.payload.data.images;
          const englishBusiness = `${response.payload.payload.data.title_en} ${response.payload.payload.data.product_name_en}`;
          this.business = `${response.payload.payload.title} ${response.payload.payload.product_name}`;
          let val_process =
            response.payload.payload.step > response.payload.payload.max_step
              ? 100
              : (response.payload.payload.step /
                  response.payload.payload.max_step) *
                100;
          //set progress bar
          this.progressValue = val_process;
          this.$forceUpdate();

          this.Ai_Text = response.payload.payload.data.gen_desc_fa;
          const Ai_Text_en = response.payload.payload.data.gen_desc_en;
          if (response.status === "success") {
            //process //failed
            //updateQr
            await this.processAiText(
              this.type,
              this.Ai_Text,
              englishBusiness,
              Ai_Text_en,
            );
            await this.genenterimageAi(englishBusiness, response);

            await this.qrUpdate(true);

            this.$forceUpdate();
          } else if (response.status === "failed") {
            //call
            this.tryprocess(this.info.data.data.auto_id);
          } else if (response.status === "process") {
            let val_process =
              response.payload.payload.step > response.payload.payload.max_step
                ? 100
                : (response.payload.payload.step /
                    response.payload.payload.max_step) *
                  100;
            //set progress bar
            this.progressValue = val_process;
            this.$forceUpdate();
          }
        })
        .catch((error) => {
          console.error("Error retrying process:", error);
          this.$toast.error("خطا در ادامه ساخت فرآیند!");
        });
    },
    cleanHtmlText(htmlText, preserveNewlines = false) {
      if (typeof htmlText !== "string") {
        return "";
      }
      if (!/<[^>]+>/.test(htmlText)) {
        const text = htmlText.trim();
        return preserveNewlines ? text : text.replace(/\s+/g, " ");
      }
      try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(
          htmlText || "<div></div>",
          "text/html",
        );
        const text = doc.body.textContent || "";
        return preserveNewlines
          ? text.trim()
          : text.trim().replace(/\s+/g, " ");
      } catch (error) {
        console.error("Error parsing HTML text:", error.message);
        return "";
      }
    },
    async processAiText(type, aiHtml, englishBusiness, englishHtml = null) {
      // Parse HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(aiHtml || "<div></div>", "text/html");
      // Extract title (first heading or fallback)
      const titleElement = doc.querySelector("h1, h2, h3") || {
        textContent: englishBusiness,
      };
      const englishDoc = englishHtml
        ? parser.parseFromString(englishHtml, "text/html")
        : null;

      const persianTitle =
        this.cleanHtmlText(titleElement.textContent) ||
        englishBusiness ||
        type === "visitcard"
          ? "کارت ویزیت"
          : type === "product"
          ? "معرفی محصول"
          : "لیبل محصول";
      // Extract description (first paragraph, div, or fallback)

      const descriptionElement = doc.querySelector("p, div") || {
        textContent: "",
      };

      const persianDescription =
        this.cleanHtmlText(descriptionElement.textContent) ||
        type === "visitcard"
          ? "توضیحات ارائه خدمات حرفه‌ای برای کسب‌وکار شما."
          : type === "product"
          ? "توضیحات ارائه خدمات حرفه‌ای برای معرفی محصول شما."
          : "توضیحات ارائه خدمات حرفه‌ای برای لیبل محصول شما.";
      // Extract features (list items or fallback)

      const listItems = Array.from(doc.querySelectorAll("li, p , div"));
      const items = listItems
        // .slice(0, 5)
        .map((li, index) => {
          // Limit to 5 features
          const strong = li.querySelector("strong, b");
          const englishLi = englishDoc?.querySelectorAll("li, p, div")[index];
          const englishStrong = englishLi?.querySelector("strong, b");
          return {
            title:
              strong?.textContent.trim() ||
              li.textContent.trim().split(":")[0]?.replace(":", "") ||
              "",
            description: strong
              ? this.cleanHtmlText(
                  li.textContent.replace(strong.textContent, ""),
                )
              : this.cleanHtmlText(
                  li.textContent
                    .split(":")
                    .slice(1)
                    .join(":")
                    ?.replace(":", ""),
                ) || li.textContent.trim(),
            original:
              englishStrong?.textContent.trim() ||
              englishLi?.textContent.trim().split(":")[0]?.replace(":", "") ||
              li.textContent.trim(),
          };
        })
        .filter((item) => item.title || item.description); // Remove empty items
      // Translate items to Persian
      const persianItems = await Promise.all(
        items.map(async (item) => ({
          title: item?.title || "ویژگی",
          description: item.description || "توضیحات",
          original: item.title || item.description,
        })),
      );
      if (persianItems.length === 0) {
        try {
          const fallbackTitle = "ویژگی";
          const fallbackDescription = "توضیحات";
          persianItems.push({
            title: fallbackTitle,
            description: fallbackDescription,
            original: "Feature",
          });
        } catch (error) {
          console.error("Fallback feature translation error:", error.message);
          persianItems.push({
            title: "ویژگی",
            description: "توضیحات",
            original: "Feature",
          });
        }
      }
      // Assign icons based on English text
      const icons = await this.assignIcons(
        items.map((item) => item.original || item.title || item.description),
      );
      // Update cardTexts
      this.cardTexts.visitName = this.business || persianTitle;
      this.cardTexts.aboutUs = this.cleanHtmlText(persianDescription)
        .toLowerCase()
        .replace("html", "")
        .replace("` `", "")
        .replace("HTML", "")
        .replace("`", "");
      this.cardTexts.extraFields = persianItems.map((item, index) => ({
        icon: icons[index] || "mdi-information",
        name: item.title,
        value: item.description,
      }));
      this.cardTexts.auto_build = null;
      this.cardTexts.auto_id = null;
      // Set dtUrl for QR code
      this.dtUrl = englishBusiness.toLowerCase().replace(/\s+/g, "-");
    },
    async assignIcons(texts) {
      const iconMap = {
        "scan|scanning|barcode|qr|read|reader|code|qrcode": "mdi-qrcode-scan",
        "precision|accuracy|target|exact|correct|pinpoint|sharp": "mdi-target",
        "durable|durability|resilient|strong|robust|tough|sturdy|hardy":
          "mdi-shield-check",
        "response|speed|fast|quick|rapid|swift|efficient|prompt":
          "mdi-clock-fast",
        "user-friendly|ease|simple|usable|intuitive|easy|accessible|straightforward":
          "mdi-account-check",
        "security|secure|safe|safety|protected|trustworthy|reliable|encrypted":
          "mdi-lock",
        "quality|high-quality|premium|superior|excellent|top-notch|exceptional":
          "mdi-star",
        "innovation|innovative|modern|advanced|cutting-edge|new|forward-thinking":
          "mdi-lightbulb-on",
        "connectivity|connection|network|wireless|bluetooth|internet|linked":
          "mdi-wifi",
        "compatibility|compatible|versatile|flexible|adaptable|universal":
          "mdi-cellphone-link",
        "portable|portability|mobile|lightweight|compact|travel-friendly":
          "mdi-briefcase",
        "battery|power|energy|long-lasting|charge|rechargeable|endurance":
          "mdi-battery",
        "design|style|stylish|elegant|aesthetic|beautiful|sleek|modern":
          "mdi-palette",
        "dimensions|size|compact|large|small|measurement|proportion":
          "mdi-ruler",
        "weight|light|heavy|lightweight|featherweight": "mdi-weight",
        "color|colour|vivid|bright|shade|hue|vibrant": "mdi-format-color-fill",
        "eco-friendly|environment|green|sustainable|recyclable|biodegradable":
          "mdi-leaf",
        "support|customer-service|assistance|help|care|aftercare|service":
          "mdi-headset",
        "versatile|multifunctional|all-in-one|multi-purpose|multi-use":
          "mdi-all-inclusive",
        "technology|tech|digital|smart|intelligent|automated": "mdi-chip",
        "global|worldwide|international|universal|cross-border": "mdi-earth",
        "affordable|cost-effective|budget-friendly|cheap|value|economical":
          "mdi-currency-usd",
        "performance|performant|powerful|strong|effective|high-performance":
          "mdi-gauge",
        "privacy|private|confidential|discreet|secure-data": "mdi-eye-off",
        "installation|setup|easy-to-install|assembly|deploy": "mdi-tools",
        "warranty|guarantee|assurance|certified|backed": "mdi-certificate",
        "accessibility|available|reach|convenient|handy": "mdi-map-marker",
        "stability|stable|dependable|consistent|steady": "mdi-anchor",
        "collaboration|teamwork|partnership|cooperation|synergy":
          "mdi-account-group",
        "information|informative|details|data|insights|knowledge":
          "mdi-information",
        "customization|customizable|personalized|tailored|bespoke": "mdi-cog",
        "scalability|scalable|expandable|grow|growth": "mdi-arrow-expand",
        "reliability|reliable|trusty|dependable|consistent": "mdi-check-circle",
        "automation|automated|self-operating|smart-operation": "mdi-robot",
        "comfort|comfortable|ergonomic|cozy|user-comfort": "mdi-sofa",
        "efficiency|efficient|optimized|streamlined|productive": "mdi-rocket",
        "weather-resistant|waterproof|dustproof|rugged":
          "mdi-weather-partly-cloudy",
        "real-time|live|instant|immediate": "mdi-update",
        "integration|integrated|seamless|connect|unified": "mdi-puzzle",
        "health|wellness|medical|care|hygiene": "mdi-hospital",
        "food|cuisine|menu|dining|culinary": "mdi-food",
        "education|learning|training|knowledge|study": "mdi-school",
        "entertainment|fun|media|leisure|enjoyment": "mdi-television",
      };
      return texts.map((text) => {
        const lowerText = text.toLowerCase();
        for (const [pattern, icon] of Object.entries(iconMap)) {
          const regex = new RegExp(`\\b(${pattern})\\b`, "i");
          if (regex.test(lowerText)) {
            return icon;
          }
        }
        return "mdi-information";
      });
    },
    async genenterimageAi(englishBusiness, response) {
      try {
        if (this.type === "product" && this.type === "labelProduct") {
          this.cardTexts.photo.profile =
            response.payload.payload.data.remove_bg_img ||
            this.cardTexts.photo.profile;

          this.cardTexts.photo.headBackground = this.images[0];
          //response.payload.payload.product_info.gallery {name images{id,url,title,description,name}} //for array
          //digikala response
          this.cardTexts.photo.gallery = this.cardTexts.photo.gallery || [
            { name: "گالری تصاویر", images: [] },
          ];
          const listImages =
            response.payload.payload.product_info.gallery?.map(
              (item, index) => ({
                url: item.images.url || "",
                title: item.images.title || "",
                name: `banner${index + 1}_${englishBusiness}`,
                id: 10001 + index,
                description: item.images.description || "",
                link: item.images.url || "",
              }),
            ) || [];
          this.cardTexts.photo.gallery[0].images = [
            ...(this.cardTexts.photo.gallery[0].images || []),
            listImages,
          ];
        } else if (this.type === "visitcard") {
          this.cardTexts.photo.profile = this.images["logo_img"];

          this.cardTexts.photo.headBackground = this.images["main_img"];

          this.cardTexts.photo.gallery = this.cardTexts.photo.gallery || [
            { name: "گالری تصاویر", images: [] },
          ];
          this.cardTexts.photo.gallery[0].images = [
            ...(this.cardTexts.photo.gallery[0].images || []),
            {
              url: this.images["banner_img_1"],
              title: "",
              name: `banner1_${englishBusiness}`,
              id: 10001,
              description: "",
              link: "",
            },
            {
              url: this.images["banner_img_2"],
              title: "",
              name: `banner2_${englishBusiness}`,
              id: 10002,
              description: "",
              link: "",
            },
            {
              url: this.images["banner_img_3"],
              title: "",
              name: `banner3_${englishBusiness}`,
              id: 10003,
              description: "",
              link: "",
            },
            {
              url: this.images["banner_img_4"],
              title: "",
              name: `banner4_${englishBusiness}`,
              id: 10004,
              description: "",
              link: "",
            },
          ];
        }
        this.$root.$emit("rerenderSwiper");
      } catch (error) {
        // this.$toast.error("خطا در ثبت تصاویر!");
        console.error(error);
      }
    },
    async fetchProgress() {
      this.loading = true;
      try {
        this.cardTexts = this.info.data.data; //JSON.stringify(this.info.data.data);
        this.checkProcess(this.info.data.data.auto_id);
        this.$nextTick(() => {
          this.$forceUpdate();
        });
        this.$toast.success("فرآیندساخت با موفقیت ادامه دارد.");

        //  this.tryprocess(this.info.data.data.auto_id);

        // this.progressValue = response.data.progress;
        // this.status = response.data.status;
      } catch (error) {
        console.error("Error fetching progress:", error);
        this.status = "failed";
        // this.progressValue = 0;
        // this.$toast.error("خطا در دریافت اطلاعات از API");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.progress-container {
  max-width: 600px;
  margin: 0 auto;
}

.status-text {
  font-size: 1.1rem;
  font-weight: bold;
}

.error-text {
  color: rgb(252, 180, 180);
}

.loading-text {
  color: rgb(170, 170, 247);
}

.completed-text {
  color: rgb(158, 247, 158);
}
.show {
  display: flex;
  flex-direction: row;
  gap: 5px;
  justify-content: center;
  justify-items: center;
  align-items: center;
}
.cover {
  display: flex;
  /* flex-direction: column; */
  gap: 5px;
}
</style>
